import { Injectable } from '@angular/core';
import { catchError, concatMap, map, Observable, of } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { InvisibleRecaptchaService } from 'src/app/core/service/invisible-recaptcha.service';

@Injectable({
  providedIn: 'root',
})
export class ComboService {
  action: string = 'register_complete';

  constructor(private readonly apiSrv: ApiService, private readonly captchaSrv: InvisibleRecaptchaService) {}

  getStates(): Observable<string[]> {
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          captcha: token,
        })),
      )
      .pipe(
        concatMap((data) => {
          return this.apiSrv.post('api/get-states', data, { showError: true, ngxSpinner: true });
        }),
      );
  }
}
